import { createReducer, on } from "@ngrx/store";
import { pagesApiActions } from "../actions/pages.actions";
import { pagesAdapter } from "../adapters/page.adapter";

export const pagesReducer = createReducer(
    pagesAdapter.getInitialState(),
    on(pagesApiActions.fetchPage, (state, { page }) => ({
        ...pagesAdapter.addOne(page,state)
    }))
)